import { CapoPlugin } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];